import { Box, Typography, styled, Stack } from '@mui/material'

const ModalBody = styled(Box)`
  padding: 8px 32px;
  width: 100%;
  height: 100%;
  flex: 1;
`

const ModalTitleWrapper = styled(Box)`
  margin-bottom: 16px;
`

const ModalSubTitle = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
`

const GroupModalContainer = styled(Stack)`
  width: 750px;
  max-width: 90%;
  max-height: 80vh;
  gap: 10px;
  overflow: auto;
  flex: 1;
`

const GroupModalSubTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
`

const GroupModalRows = styled(Stack)`
  gap: 10px;
  flex: 1;
`

export {
  ModalBody,
  ModalTitleWrapper,
  ModalSubTitle,
  GroupModalContainer,
  GroupModalSubTitle,
  GroupModalRows,
}
